export class PersonaGiuridicaBaseDTO {
	codTipoDelega: string;
	codiceFiscale: string;
	formaGiuridica: string;
	idPersona: string;
	indirizzo: string;
	pIva: string;
	ragioneSociale: string;
	tipoDelega: string;
	validata: string;
}

export function nuovaPGBase() : PersonaGiuridicaBaseDTO {
	let newPG: PersonaGiuridicaBaseDTO = new PersonaGiuridicaBaseDTO();
	newPG.ragioneSociale = 'nuova-persona-giuridica';
	newPG.idPersona = 'nuovo';
	newPG.codTipoDelega = '';

	return newPG;
}
